<template>
  <div>
    <v-row v-if="isMounted && !value">
      <v-col align="center">
        <v-progress-circular
          :size="80"
          color="red-darken-2"
          indeterminate
        ></v-progress-circular>
      </v-col>
    </v-row>

    <v-row v-if="value && !value.length">
      <v-col>
        <v-alert color="info" type="info">
          We’re sorry, there are no resources at this time. Please check back
          later.
        </v-alert>
      </v-col>
    </v-row>

    <template v-if="value && value.length">
      <v-row justify="space-around">
        <v-col v-for="item in value" :key="item.id" cols="12" sm="6" xl="3">
          <PromotedResourceCard :value="item" />
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script setup>
import { useMounted } from '@vueuse/core'

defineProps({
  value: {
    default: undefined,
    type: Array
  }
})

const isMounted = useMounted()
</script>
